import axios from "axios";
import cloneDeep from "lodash/cloneDeep";
const returnPublishedData = (show_object, rootState) => {
  // Make slideArray copy as not to mutate original or its references.
  var slideArray = cloneDeep(show_object.data.slideArray);
  var publishData = {
    slideArray: slideArray.map(item => {
      delete item.id;
      // Blank out the movement data for json files.
      item.end_percent_scale = 100;
      item.end_percent_x = 0;
      item.end_percent_y = 0;
      item.start_percent_scale = 100;
      item.start_percent_x = 0;
      item.start_percent_y = 0;
      item.has_motion = false;
      return item;
    }),
    audioFile: show_object.data.audio,
    key: show_object.key,
    publishedAt: new Date().getTime(),
    title: show_object.title,
    overlayArray: show_object.data.overlayArray,
    displaySettings: show_object.data.displaySettings,
    imageSizes: rootState.imageSizes,
    formatVersion: 3
  };
  return publishData;
};

const writeDataToFile = (key, publishData, show_object, callback) => {
  // Put data into a file blob.
  var fileObj = new Blob([JSON.stringify(publishData)], {
    type: "application/json"
  });

  let formData = new FormData();
  var fields = show_object.jsonCredentialsV4.fields;
  for (const [key, value] of Object.entries(fields)) {
    // Don't add key, we want the slug as the name.
    if (key != "key") {
      formData.append(key, value);
    }
  }
  formData.append("key", key); // Necessary as fields key includes ${filename}
  formData.append("acl", "public-read");
  formData.append("success_action_status", "201");
  formData.append("Content-Type", "application/json");
  formData.append("Cache-Control", "no-cache");
  formData.append("file", fileObj);

  axios
    .post(
      `https://${show_object.jsonCredentialsV4.bucket}.s3.amazonaws.com/`,
      formData,
      {
        onUploadProgress: progressEvent => {
          console.log(progressEvent);
          var _uploaded = Math.ceil(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          console.log(_uploaded);
          console.log(`https://cdn3.soundslides.com/${key}`);
        }
      }
    )
    .then(function(e) {
      console.log(e);
      console.log("SUCCESS!!");
      if (callback) {
        callback();
      }
    });
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    publishJson({ dispatch }, show_object) {
      // console.log(show_object);
      // It is possible that privacyState is not defined (pre-Aug 7th, 2019)
      if (!show_object.privacyState) {
        if (show_object.published) {
          show_object.privacyState = "world";
        } else {
          show_object.privacyState = "private";
        }
      }
      // Check to see if json publication is needed.
      if (show_object.privacyState === "private") {
        // Show is private, no json publishing is needed.
        // NOTE: The user can not change the privacy setting in the editor.
        // If the user ever gets the ability to change privacy setting, you
        // will need to revisit this code (ie require json pub in more conditions)
        return true;
      }
      // NOTE: No empty json publishing is required here, as there is no ability
      // for user to change privacy in the editor.
      if (show_object.privacyState === "world") {
        // public json, no private json.
        dispatch("showsJson/writeWorldJson", show_object, { root: true });
      }
      if (show_object.privacyState === "privateLink") {
        // public json, no private json.
        dispatch("showsJson/writePrivateLinkJson", show_object, { root: true });
      }
      if (show_object.privacyState === "password") {
        dispatch("showsJson/writePasswordJson", show_object, { root: true });
      }
    },
    writeWorldJson({ rootState }, show_object) {
      console.log("writeWorldJson");
      // Define all published data for the json file.
      var publishData = returnPublishedData(show_object, rootState);
      var key = "json/" + show_object.key + "/data.json";
      var callback = () => {
        // Open in new window.
        //window.open(
        //  `https://play.soundslides.org/${show_object.key}`,
        //  "_blank"
        //);
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writePrivateLinkJson({ rootState }, show_object) {
      console.log("writePrivateLinkJson");
      // Define all published data for the json file.
      var publishData = returnPublishedData(show_object, rootState);
      var key =
        "json/" +
        show_object.key +
        "/" +
        show_object.privateLinkKey +
        "/" +
        "data.json";
      var callback = () => {
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    },
    writePasswordJson({ rootState }, show_object) {
      console.log("writePasswordJson");
      var publishData = returnPublishedData(show_object, rootState);
      var key =
        "json/" +
        show_object.key +
        "/" +
        show_object.privateLinkKey +
        "/" +
        show_object.passwordFileKey +
        "/data.json";
      var callback = () => {
        // Record state no longer publishing.
        rootState.publishingInProgress = false;
      };
      writeDataToFile(key, publishData, show_object, callback);
    }
  }
};
